module.exports = __webpack_public_path__ + "static/media/memory.30861417.svg";